import React from "react";
import { Link } from "react-router-dom";

function BlogStoriesV1() {
  return (
    <section className="v1-stories-section">
      <div className="v1-stories-inner">
        <div className="v1-stories-header">
          <div>
            <h2 className="v1-stories-title">Travel Stories & Guides</h2>
            <p className="v1-stories-subtitle">
              Inspiration, tips and local secrets from our community of travelers.
            </p>
          </div>

          <Link to="/blogs" className="v1-link-view-all">
            <span>Read more stories</span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </Link>
        </div>

        <div className="v1-stories-grid">
          {/* Featured Large Article (Left) */}
          <Link to="/blogs" className="v1-story-featured-card">
            <div className="v1-story-img-container">
              <img
                src="https://images.unsplash.com/photo-1528728329032-2972f65dfb3f?auto=format&fit=crop&w=1000&q=80"
                alt="10 Must-Visit Places in Australia"
                className="v1-story-img"
              />
              <span className="v1-story-badge">Travel Guide</span>
            </div>

            <div className="v1-story-featured-body">
              <h3 className="v1-story-featured-title">
                10 Must-Visit Places in Australia for First-Time Travelers
              </h3>

              <div className="v1-story-meta-row">
                <div className="v1-story-meta-item">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="3" y1="10" x2="21" y2="10" />
                  </svg>
                  <span>Oct 12, 2024</span>
                </div>

                <div className="v1-story-meta-item">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                  <span>6 min read</span>
                </div>
              </div>
            </div>
          </Link>

          {/* Side Articles (Right Column) */}
          <div className="v1-stories-side-list">
            {/* Story 1 */}
            <Link to="/blogs" className="v1-story-side-card">
              <div className="v1-story-side-thumb">
                <img
                  src="https://images.unsplash.com/photo-1544551763-46a013bb70d5?auto=format&fit=crop&w=400&q=80"
                  alt="Great Barrier Reef"
                />
                <span className="v1-story-side-badge">Local Secrets</span>
              </div>
              <div className="v1-story-side-content">
                <h3 className="v1-story-side-title">
                  A Local’s Guide to the Great Barrier Reef
                </h3>
                <div className="v1-story-meta-row">
                  <div className="v1-story-meta-item">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                      <line x1="16" y1="2" x2="16" y2="6" />
                      <line x1="8" y1="2" x2="8" y2="6" />
                      <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                    <span>Oct 8, 2024</span>
                  </div>
                  <div className="v1-story-meta-item">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    <span>4 min read</span>
                  </div>
                </div>
              </div>
            </Link>

            {/* Story 2 */}
            <Link to="/blogs" className="v1-story-side-card">
              <div className="v1-story-side-thumb">
                <img
                  src="https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?auto=format&fit=crop&w=400&q=80"
                  alt="Australian Food Experiences"
                />
                <span className="v1-story-side-badge">Food & Drink</span>
              </div>
              <div className="v1-story-side-content">
                <h3 className="v1-story-side-title">
                  Top 5 Australian Food Experiences You Can’t Miss
                </h3>
                <div className="v1-story-meta-row">
                  <div className="v1-story-meta-item">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                      <line x1="16" y1="2" x2="16" y2="6" />
                      <line x1="8" y1="2" x2="8" y2="6" />
                      <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                    <span>Sep 28, 2024</span>
                  </div>
                  <div className="v1-story-meta-item">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    <span>5 min read</span>
                  </div>
                </div>
              </div>
            </Link>

            {/* Story 3 */}
            <Link to="/blogs" className="v1-story-side-card">
              <div className="v1-story-side-thumb">
                <img
                  src="https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=400&q=80"
                  alt="Blue Mountains Trails"
                />
                <span className="v1-story-side-badge">Outdoors</span>
              </div>
              <div className="v1-story-side-content">
                <h3 className="v1-story-side-title">
                  Hiking in the Blue Mountains: Trails, Tips and Views
                </h3>
                <div className="v1-story-meta-row">
                  <div className="v1-story-meta-item">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                      <line x1="16" y1="2" x2="16" y2="6" />
                      <line x1="8" y1="2" x2="8" y2="6" />
                      <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                    <span>Sep 20, 2024</span>
                  </div>
                  <div className="v1-story-meta-item">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    <span>7 min read</span>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BlogStoriesV1;
